import { useFeatureFlags } from 'utils/features';

export default function useCustomFieldsEnabled() {
  return useFeatureFlags('CUSTOM_FIELDS');
}
